(function () {
  if (window.dpMapCountStarted) return;
  window.dpMapCountStarted = true;
  // Historical completed maps from the retired backend; new API includes this baseline.
  function paint(count) {
    document.querySelectorAll('[data-map-count]').forEach(function (element) {
      element.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en').format(count);
      element.closest('[data-map-count-proof]').style.visibility = 'visible';
    });
  }
  paint(1559);
  async function refresh() {
    try {
      var response = await fetch('https://dearplace-map-public-thgnkdml6q-ew.a.run.app/api/public/map-count', { credentials: 'omit', signal: AbortSignal.timeout(10000) });
      if (!response.ok) throw new Error('Count unavailable');
      var data = await response.json();
      if (!Number.isSafeInteger(data.count) || data.count < 0) return;
      paint(data.count);
    } catch (_) { /* Keep the last verified count, or the fixed historical baseline. */ }
  }
  refresh();
  setInterval(function () { if (!document.hidden) refresh(); }, 300000);
})();
